var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function cartesian() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = [];
    var maxIdx = args.length - 1;
    var combine = function (current, prefix) {
        if (current === void 0) { current = 0; }
        if (prefix === void 0) { prefix = []; }
        for (var i = 0; i < args[current].length; i++) {
            var prefixCopy = __spreadArray([], __read(prefix), false);
            prefixCopy.push(args[current][i]);
            if (current === maxIdx) {
                result.push(prefixCopy);
                continue;
            }
            combine(current + 1, prefixCopy);
        }
    };
    combine();
    return result;
}
